import { render, staticRenderFns } from "./LandingTermsMain.vue?vue&type=template&id=100c5feb&scoped=true"
import script from "./LandingTermsMain.vue?vue&type=script&lang=js"
export * from "./LandingTermsMain.vue?vue&type=script&lang=js"
import style0 from "./LandingTermsMain.vue?vue&type=style&index=0&id=100c5feb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c5feb",
  null
  
)

export default component.exports